import { render, staticRenderFns } from "./BankAccountsFilter.vue?vue&type=template&id=66437552&scoped=true&"
import script from "./BankAccountsFilter.vue?vue&type=script&lang=js&"
export * from "./BankAccountsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66437552",
  null
  
)

export default component.exports